import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles'; // Ensure you are using css-loader
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import { settings } from '@/config';
import i18n from '@/locale';
import locales from '@/locale/vuetify';
import { VTimePicker } from 'vuetify/labs/VTimePicker';

const light = {
	dark: false,
	colors: {
		background: '#fff',
		surface: '#FAFBFC',
		primary: '#8CC63F',
		secondary: '#E9951E',
		error: '#FF5722',
		info: '#4496F3',
		success: '#8cc63f',
		warning: '#E9951E',
	},
  variables: {},
};

const dark = {
	dark: true,
	colors: {
		background: '#181833',
		surface: '#161644',
		primary: '#f9c22e',
		secondary: '#2ec4ff',
		// 'secondary-darken-1': '#03adf4',
		error: '#FF5722',
		info: '#4496F3',
		success: '#16DB93',
		warning: '#E9951E',
	},
  variables: {},
};

const opts = {
	components: {
		...components,
		VTimePicker
	},
	directives,
	theme: {
		defaultTheme: 'light',
		themes: {
			light,
			dark,
		},
	},
	icons: {
		defaultSet: 'mdi', // This is already the default value - only for display purposes
	},
	locale: {
    locale: settings.locale,
    messages: { ...locales },
		t: (key, ...params) => i18n.t(key, params),
  },
};

export default function (app) {
	app.use(createVuetify(opts))
}
  